(ns manage.feed-mapping-table.view
  (:require ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.table :as t]
            [manage.feed-importer-ocp.db :as form]
            [manage.feed-mapping-table.hooks :as hooks]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui format-reference [{:keys [idx]}]
  (let [sanitized? (some #(= idx %) (use-subscribe [:form.feed-importer/sanitized-fields]))
        indexed? (some #(= idx %) (use-subscribe [:form.feed-importer/indexed-fields]))]
    ($ Stack {:flex 1}
       ($ form-field
          {:err-msg (form/use-error-message [:raw-mappings idx :to])
           :sx #js {:flex 1}}
          ($ input (form/use-bind-control [:raw-mappings idx :to])))
       (when sanitized?
         ($ Typography
            {:component "p"
             :variant "caption"
             :fontWeight "600"
             :sx #js {:color "warning.main"
                      :mt 1}}
            "Incorrect formatting automatically changed"))
       (when indexed?
         ($ Typography
            {:component "p"
             :variant "caption"
             :fontWeight "600"
             :sx #js {:color "warning.main"
                      :mt 1}}
            "Duplicate name automatically changed")))))

(defui format-product-field-reference [{:keys [idx]}]
  (let [options (hooks/use-product-store-fields)]
    ($ form-field
       {:err-msg (form/use-error-message [:raw-mappings idx :to])
        :sx #js {:flex 1}}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:raw-mappings idx :to])
                         {:options options})]))))

(defmulti columns
  (fn [type] type))

(defmethod columns :default []
  [{:id :name-type
    :label "fieldname"
    :format :fieldname
    :sortable? false}
   {:id :ref
    :label "internal reference"
    :format #($ format-reference %)
    :sortable? false}])

(defmethod columns :product []
  [{:id :name-type
    :label "fieldname"
    :format :fieldname
    :sortable? false}
   {:id :ref
    :label "product store field"
    :format #($ format-product-field-reference %)
    :sortable? false}])

(defui row
  [{:keys [idx fieldname] :as mapping}]
  (let [feed-type (use-subscribe [:table.feed/feed-type])
        row-selected? (use-subscribe [:form.feed-importer/row-selected? idx])]
    (r/as-element
     [t/table-row {:selected? row-selected?
                   :data-testid :table-feed-mapping-data-row
                   :style {:min-height "7rem"}}
      [t/table-cell {:style {:max-width 68}}
       ($ checkbox
          {:value row-selected?
           :id fieldname
           :on-change #(if %
                         (rf/dispatch [:form.feed-importer/select-row idx])
                         (rf/dispatch [:form.feed-importer/deselect-row idx]))})]
      (doall
       (for [{:keys [id format]} (columns feed-type)]
         [t/table-cell
          {:key id
           :data-testid (str "table-feed-mapping__column--" (name id))}
          (format mapping)]))])))

(defui head
  [{:keys [id label sortable?]}]
  (let [sort-direction (use-subscribe [:table.feed/sort-direction id])]
    (r/as-element
     (if sortable?
       [t/table-head-sortable
        {:sort-direction sort-direction
         :on-click #(rf/dispatch [:table.feed/sort-column id])}
        label]
       [t/table-head {}
        label]))))

(defui table
  []
  (let [feed-type (use-subscribe [:table.feed/feed-type])
        {:keys [state value]} (use-subscribe [:table.feed-mapping/value])
        search (use-subscribe [:table.feed-mapping/search-term])
        selected-state (use-subscribe [:form.feed-importer/selected-state])]
    (r/as-element
     [t/table {:data-testid :table-feed-mapping}
      [t/table-row {}
       [t/table-head {:style {:max-width 68}}
        ($ checkbox
           {:id "toggle-all-rows"
            :value (not= selected-state :none)
            :indeterminate (or (= selected-state :partial) false)
            :on-change #(if (= selected-state :all)
                          (rf/dispatch [:form.feed-importer/deselect-all-rows])
                          (rf/dispatch [:form.feed-importer/select-all-rows]))})]
       (for [{:keys [id] :as column} (columns feed-type)]
         ($ head (assoc column :key id)))]
      (cond
        (= :failure state) [t/table-message "We could not load any feed data, please provide a valid feed in the previous step."]
        (= :pending state) [t/table-message "Loading fields"]
        (and (not-empty search)
             (empty? value)) [t/table-message "No fields found for this term"]
        (empty? value) [t/table-message "We could not load any feed data, please provide a valid feed in the previous step."]
        (= :success state)
        (for [[idx fieldname] (mc/seq-indexed value)]
          ($ row {:key fieldname :idx idx :fieldname fieldname})))])))
